import React from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { RadioButtonGroup, DatePickerElement } from 'react-hook-form-mui';
import GenericModalForm from '../GenericModalForm';
import ar from './ar.json';
import en from './en.json';
import { LocaleContext } from '../../../../contexts/language';

import { IntlProvider } from 'react-intl';
import BasicEnquiryFormFields from '../../../atoms/BasicEnquiryFormFields';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

const languages = {
  ar,
  en
};


export const TestDriveFormModal = ({
  availableBranches, onSubmit, providerId,
  modelId,
  trimLevelId,
  offerId, ...rest
}) => {

  const localeConfig = React.useContext(LocaleContext);

  return (
    <IntlProvider locale={localeConfig?.lang} messages={languages[localeConfig?.lang] || languages.en}>
      <GenericModalForm
        {...rest}
        onSubmit={({ formValues: { testDriveDate, ...rest } }) => onSubmit({
          formValues: {
            ...rest,
            testDriveDate: testDriveDate.format('YYYY-MM-DD')
          }
        })}
        defaultValues={{
          firstName: '',
          lastName: '',
          message: '',
          emailAddress: '',
          phoneNumber: '',
          testDriveDate: undefined,
          branch: availableBranches?.length === 1 ? availableBranches[0]?.uuid : undefined,
          testDriveTime: undefined,
          providerId,
          modelId,
          trimLevelId,
          offerId
        }}
        // editTitle={'Edit Person'}
        addTitle={'Book a Test Drive'}
        editTitle={'Book a Test Drive'}

        onSubmitText={'Book'}
        onSubmitTitle={'Book'}
        onNewSnackText={'Test Drive Reservation Sent'}
        onEditSnackText={'Test Drive Reservation Sent'}>
        {({ loading }) => (
          <>
            <BasicEnquiryFormFields loading={loading} />


            <Grid xs={12} md={6}>
              <DatePickerElement
                sx={{ width: '100%' }}
                disabled={loading}
                minDate={dayjs().add(2, 'day')}
                parseError={(err) => err?.message}
                fullWidth
                name={'testDriveDate'}
                // required
                label={'When would you have the test drive?'}
                helperText={'Select a date that you want to do the test drive'}
              />
            </Grid>

            <Grid xs={12} md={6}>
              <RadioButtonGroup
                row
                label={'What time of day?'}
                name={'testDriveTime'}
                disabled={loading}
                fullWidth
                parseError={(err) =>
                  err.type === 'required' ? 'Select at least one option' : err.message
                }
                // helperText={'Select which role(s) they have within your organization'}
                options={[9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21].map(hour => {
                  const t = new Date();
                  t.setHours(hour, 0);
                  return {
                    id: `${String(hour).padStart(2, '0')}:00`,
                    label: `${String(hour).padStart(2, '0')}:00`
                  };
                })}
              />
            </Grid>
            {availableBranches.length > 1 ? (
              <Grid xs={12} md={6}>
                <RadioButtonGroup
                  label={'What Branch?'}
                  name={'branch'}
                  disabled={loading}
                  fullWidth
                  parseError={(err) =>
                    err.type === 'required' ? 'Select at least one option' : err.message
                  }
                  // helperText={'Select which role(s) they have within your organization'}
                  options={availableBranches.map(({ uuid, name, address }) => {
                    return {
                      id: uuid,
                      label: `${name} - ${address}`
                    };
                  })}
                />
              </Grid>
            ) : null}
          </>
        )}
      </GenericModalForm>
    </IntlProvider>
  );
};

TestDriveFormModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  availableBranches: PropTypes.arrayOf(PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired
  }).isRequired).isRequired
};
TestDriveFormModal.defaultProps = {
  onClose: () => {
  },
  open: false,
  availableBranches: []
};

export default TestDriveFormModal;